// RideWyze & Road Runner

import loginBg from "../assets/loginback.png";
import loginlogo from "../assets/biglogo.png";
import bgImg from "../assets/images/back.png";
import logo from "../assets/dashboard.png";
import walletLogo from "../assets/logo.png";
import { default as EmailTemplateRR } from '../assets/Email Template.png';




//Women First
import womenLoginBg from "../assets/womens-first/women-login.jpg";
import wfloginlogo from "../assets/womens-first/logopurple.png";
import wfBgImg from '../assets/womens-first/womenbg.png';
import wfLogo from "../assets/womens-first/logowhite.png";
import wfWalletLogo from "../assets/womens-first/logowithpbg.png";
import { default as EmailTemplateWF } from '../assets/email-template-wf.png';





//Tornado

import tornadoLogin from '../assets/tornado/tornadoLogo.png'
import tornadoLogo4 from '../assets/tornado/tornadoLogo.png'
import tornadoLogo from '../assets/tornado/tornadoTNW.png'
import tornadoTab from '../assets/tornado/tornadoT.png'
import tornadoWallet from '../assets/tornado/tornadoTw.png'
import tornadoLoading from '../assets/tornado/tornadoLoading (2).png'
import tornadoLogo3 from '../assets/images/logoTornado.png'
import tornadoBgImg from '../assets/tornado/TopbarBackgroundTornado.png'
import tornadoLoginBg from "../assets/tornado/bgImg.png";
import emailTemplateTornado from '../assets/tornado/emailTempTor.png';


//Khalil

import khalilLogo from '../assets/khalil-logo.png'
import khalilBgImg from '../assets/khalil/topbar.jpeg'
import khalilLoginBg from "../assets/khalil/loginbg.png";
import emailTemplatekhalil from '../assets/khalil/emailTempKh.png';
import tamamLogo from '../assets/khalil/tamam-logo.png'
import emailTemplateTmam from '../assets/khalil/emailTempTm.jpeg';



//tkram
import tkramTabLogo from '../assets/tkram/tkramT.png'
import tkramLogInLogo from '../assets/tkram/logInLogo.png'
import tkramLoadingLogo from '../assets/tkram/tkramT.png'
import tkramLogoTWWithBgB from '../assets/tkram/tkramLogoTWWithBgB.png'
import tkramFullB from '../assets/tkram/tkramFullB.png'


import tkramBgImg from '../assets/tkram/TopbarBackgroundTkram.png'
import tkramLoginBg from "../assets/tkram/tkramLoginBg.jpeg";
import emailTemplateTkram from '../assets/tkram/emailTemplateTkram.png';



const projectConfig = {

    production: {
        projectId: "ridewyze",
        language: 'en',
        distanceUnit: "Mile",
        country: 'us',
        tabIcon: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
        logo: logo,
        walletLogo: walletLogo,
        walletLogoBgColor: false,
        title: 'RideWyze',
        short_title: 'RW',
        email: "ridewyze@gmail.com",
        emailTemplate: EmailTemplateRR,
        bgImg: bgImg,
        login: {
            loginBgImg: loginBg,
            loginLogoBgColor: false,
            loginlogo: loginlogo,
            loginlogoSize: "100%"
        },
        theme: {
            mainColor: '#006496',
            ligthMain: '#f5fcff',
            meduimColor: '#C0EAFF',
            excelJS: 'ff006496',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'RideWyze | Manage Your Rides & Earnings',
            description: 'Welcome to RideWyze. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
            type: 'website',
        },
        dispatcherSocket: false,
        firebase: true,
        chat: false,
        notifications: true,
        platform_fee: true,
        company_fee: true,
        fixed_otp: true,
        male_female: true,
        language_menu: false,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: false,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_DEVELOPMENT,
    },
    production_v2: {
        projectId: "ridewyze-v2",
        language: 'en',
        distanceUnit: "Mile",
        country: 'us',
        tabIcon: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
        logo: logo,
        walletLogo: walletLogo,
        walletLogoBgColor: false,
        title: 'RideWyze',
        short_title: 'RW',
        email: "ridewyze@gmail.com",
        emailTemplate: EmailTemplateRR,
        bgImg: bgImg,
        login: {
            loginBgImg: loginBg,
            loginLogoBgColor: false,
            loginlogo: loginlogo,
            loginlogoSize: "100%"
        },
        theme: {
            mainColor: '#006496',
            ligthMain: '#f5fcff',
            meduimColor: '#C0EAFF',
            excelJS: 'ff006496',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'RideWyze | Manage Your Rides & Earnings',
            description: 'Welcome to RideWyze. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
            type: 'website',
        },
        dispatcherSocket: false,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: false,
        language_menu: false,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: false,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_DEVELOPMENT,
    },
    women_first: {
        projectId: "women-s-first",
        language: 'en',
        distanceUnit: "km",
        country: 'ca',
        tabIcon: 'https://firebasestorage.googleapis.com/v0/b/women-s-first.appspot.com/o/logowithpbg.png?alt=media&token=8331add6-6447-4902-a9fe-21afc075b46a',
        logo: wfLogo,
        walletLogo: wfWalletLogo,
        walletLogoBgColor: true,
        title: 'Women First',
        short_title: 'WF',
        bgImg: wfBgImg,
        email: "women_first@gmail.com",
        emailTemplate: EmailTemplateWF,
        login: {
            loginBgImg: womenLoginBg,
            loginLogoBgColor: false,
            loginlogo: wfloginlogo,
            loginlogoSize: "50%"


        },
        theme: {
            mainColor: '#431799',
            ligthMain: '#F9F6FF',
            meduimColor: '#D4C7FC',
            excelJS: 'ff431799',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Women First | Manage Your Rides & Earnings',
            description: 'Welcome to Women First. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: 'https://firebasestorage.googleapis.com/v0/b/women-s-first.appspot.com/o/logowithpbg.png?alt=media&token=8331add6-6447-4902-a9fe-21afc075b46a',
            type: 'website',
        },
        dispatcherSocket: false,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: true,
        language_menu: false,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: false,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_WOMEN_FIRST,

    },
    tornado: {
        projectId: "tornado",
        language: 'ar',
        distanceUnit: "km",
        country: 'jo',
        tabIcon: tornadoTab,
        logo: tornadoLogo,
        chatLogo: tornadoLogo3,
        loadingLogo: tornadoLoading,
        LoadingBorderRadius: "none",
        walletLogo: tornadoWallet,
        walletLogoBgColor: true,
        title: 'Tornado',
        short_title: 'TOR',
        bgImg: tornadoBgImg,
        email: "tornado@gmail.com",
        emailTemplate: emailTemplateTornado,
        login: {
            loginBgImg: tornadoLoginBg,
            loginLogoBgColor: false,
            loginlogo: tornadoLogin,
            loginlogoSize: "50%"
        },
        theme: {
            mainColor: '#01386b',
            ligthMain: '#F2FAFF',
            meduimColor: '#B3E0FF',
            excelJS: 'ff01386b',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tornado | Manage Your Rides & Earnings',
            description: 'Welcome to Tornado. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tornadoLogo4,
            type: 'website',
        },
        dispatcherSocket: true,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: true,
        language_menu: true,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: true,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_TORNADO,
        notificationSound: true,
    },
    tornado_dev: {
        projectId: "tornado-dev",
        language: 'ar',
        distanceUnit: "Km",
        country: 'jo',
        tabIcon: tornadoTab,
        logo: tornadoLogo,
        chatLogo: tornadoLogo3,
        loadingLogo: tornadoLoading,
        LoadingBorderRadius: "none",
        walletLogo: tornadoWallet,
        walletLogoBgColor: true,
        title: 'Tornado Dev',
        short_title: 'TOR-D',
        bgImg: tornadoBgImg,
        email: "tornado@gmail.com",
        emailTemplate: emailTemplateTornado,
        login: {
            loginBgImg: tornadoLoginBg,
            loginLogoBgColor: false,
            loginlogo: tornadoLogin,
            loginlogoSize: "50%"
        },
        theme: {
            mainColor: '#01386b',
            ligthMain: '#F2FAFF',
            meduimColor: '#B3E0FF',
            excelJS: 'ff0086FF',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tornado Dev | Manage Your Rides & Earnings',
            description: 'Welcome to Tornado. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tornadoLogo4,
            type: 'website',
        },
        dispatcherSocket: true,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: true,
        language_menu: true,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: true,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_TORNADO_DEVELOPMENT,
        notificationSound: true,
    },
    khalil: {
        projectId: "khalil",
        language: 'en',
        distanceUnit: "km",
        country: 'iq',
        tabIcon: tamamLogo,
        logo: tamamLogo,
        walletLogo: tamamLogo,
        walletLogoBgColor: true,
        title: 'Tamam',
        short_title: 'TM',
        bgImg: khalilBgImg,
        email: "tamam@gmail.com",
        emailTemplate: emailTemplateTmam,
        login: {
            loginBgImg: khalilLoginBg,
            loginLogoBgColor: true,
            loginlogo: tamamLogo,
            loginlogoSize: "40%"
        },
        theme: {
            mainColor: '#051D3F',
            ligthMain: '#F4F9FF',
            meduimColor: '#B9D9FF',
            excelJS: 'ff051D3F',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tamam | Manage Your Rides & Earnings',
            description: 'Welcome to Tamam. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tamamLogo,
            type: 'website',
        },
        dispatcherSocket: false,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: true,
        language_menu: true,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: false,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_KHALIL,

    },
    //  khalil: {
    //     projectId: "khalil",
    //     language: 'en',
    // distanceUnit:"km",    
    // country: 'iq',
    //     tabIcon: tamamLogo,
    //     logo: tamamLogo,
    // walletLogo: tamamLogo,
    // walletLogoBgColor:true,    
    //     title: 'Tamam',
    //     short_title: 'KH',
    //     bgImg: khalilBgImg,
    //     email: "khalil@gmail.com",
    //     emailTemplate: emailTemplatekhalil,
    //     login: {
    //         loginBgImg: khalilLoginBg,
    // loginLogoBgColor:true,        
    // loginlogo: tamamLogo,
    //         loginlogoSize: "40%"
    //     },
    //     theme: {
    //         mainColor: '#051D3F',
    //         ligthMain: '#F4F9FF',
    //         meduimColor: '#B9D9FF',
    //         excelJS: 'ff051D3F',
    //         hoverBg: 'white',
    //         sidebar: {
    //             color: "#eeeeee"
    //         }
    //     },
    //     og: {
    //         title: 'Khalil | Manage Your Rides & Earnings',
    //         description: 'Welcome to Khalil. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
    //         image: khalilLogo,
    //         type: 'website',
    //     },
    //dispatcherSocket:false,
    // firebase: true, 
    //chat: true,
    // notifications: true,
    // fixed_otp:false,
    // male_female:true,
    // language_menu:true,    
    // del_activeRide_id:false,
    // ride_history_imgWithApi:false,
    // edit_driver_customer_phone_number:false,
    // stripeKey: process.env.REACT_APP_STRIPE_KEY_KHALIL,
    // },
    khalil_dev: {
        projectId: "khalil-dev",
        language: 'en',
        distanceUnit: "km",
        country: 'iq',
        tabIcon: khalilLogo,
        logo: khalilLogo,
        walletLogo: khalilLogo,
        walletLogoBgColor: true,
        title: 'Khalil Dev',
        short_title: 'KH-D',
        bgImg: khalilBgImg,
        email: "khalil@gmail.com",
        emailTemplate: emailTemplatekhalil,
        login: {
            loginBgImg: khalilLoginBg,
            loginLogoBgColor: true,
            loginlogo: khalilLogo,
            loginlogoSize: "40%"
        },
        theme: {
            mainColor: '#051D3F',
            ligthMain: '#F4F9FF',
            meduimColor: '#B9D9FF',
            excelJS: 'ff051D3F',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Khalil | Manage Your Rides & Earnings',
            description: 'Welcome to Khalil. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: khalilLogo,
            type: 'website',
        },
        dispatcherSocket: false,
        firebase: true,
        chat: true,
        notifications: true,
        fixed_otp: false,
        male_female: true,
        language_menu: true,
        del_activeRide_id: false,
        ride_history_imgWithApi: false,
        edit_driver_customer_phone_number: false,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_KHALIL_DEVELOPMENT,
    },
    tkram: {
        projectId: "tkram-prod",
        language: 'ar',
        distanceUnit: "km",
        country: 'sy',
        tabIcon: tkramTabLogo,
        logo: tkramFullB,
        loadingLogo: tkramLoadingLogo,
        walletLogo: tkramLogoTWWithBgB,
        walletLogoBgColor: false,
        title: 'Tkram',
        short_title: 'TK',
        bgImg: tkramBgImg,
        email: "info@tkramride.com",
        emailTemplate: emailTemplateTkram,
        login: {
            loginBgImg: tkramLoginBg,
            loginLogoBgColor: false,
            loginlogo: tkramLogInLogo,
            loginlogoSize: "60%"
        },
        theme: {
            mainColor: '#747DFE',
            ligthMain: '#D4D9FF',
            meduimColor: '#D4D9FF',
            excelJS: 'ff747DFE',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tkram | Manage Your Rides & Earnings',
            description: 'Welcome to Tkram . Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tkramLogoTWWithBgB,
            type: 'website',
        },
        dispatcherSocket: true,
        firebase: false,
        chat: false,
        notifications: false,
        platform_fee: true,
        company_fee: true,
        fixed_otp: true,
        male_female: true,
        language_menu: true,
        del_activeRide_id: true,
        ride_history_imgWithApi: true,
        edit_driver_customer_phone_number: true,
        admin_notes: true,
        is_company_driver: true,
        customDirections: true,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_TKRAM,
    },
    tkram_stg: {
        projectId: "tkram-stg",
        language: 'ar',
        distanceUnit: "km",
        country: 'sy',
        tabIcon: tkramTabLogo,
        logo: tkramFullB,
        loadingLogo: tkramLoadingLogo,
        walletLogo: tkramLogoTWWithBgB,
        walletLogoBgColor: false,
        title: 'Tkram Stg',
        short_title: 'TK-S',
        bgImg: tkramBgImg,
        email: "info@tkramride.com",
        emailTemplate: emailTemplateTkram,
        login: {
            loginBgImg: tkramLoginBg,
            loginLogoBgColor: false,
            loginlogo: tkramLogInLogo,
            loginlogoSize: "60%"
        },
        theme: {
            mainColor: '#747DFE',
            ligthMain: '#D4D9FF',
            meduimColor: '#D4D9FF',
            excelJS: 'ff747DFE',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tkram STG | Manage Your Rides & Earnings',
            description: 'Welcome to Tkram STG . Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tkramLogoTWWithBgB,
            type: 'website',
        },
        firebase: true,
        chat: false,
        notifications: false,
        platform_fee: true,
        company_fee: true,
        fixed_otp: true,
        male_female: true,
        language_menu: true,
        del_activeRide_id: true,
        ride_history_imgWithApi: true,
        edit_driver_customer_phone_number: true,
        admin_notes: true,
        is_company_driver: true,
        customDirections: true,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_TKRAM_STG,
    },
    tkram_dev: {
        projectId: "tkram-dev",
        language: 'ar',
        distanceUnit: "Km",
        country: 'sy',
        tabIcon: tkramTabLogo,
        logo: tkramFullB,
        loadingLogo: tkramLoadingLogo,
        walletLogo: tkramLogoTWWithBgB,
        walletLogoBgColor: false,
        title: 'Tkram Dev',
        short_title: 'TK-D',
        bgImg: tkramBgImg,
        email: "info@tkramride.com",
        emailTemplate: emailTemplateTkram,
        login: {
            loginBgImg: tkramLoginBg,
            loginLogoBgColor: false,
            loginlogo: tkramLogInLogo,
            loginlogoSize: "60%"
        },
        theme: {
            mainColor: '#747DFE',
            ligthMain: '#D4D9FF',
            meduimColor: '#D4D9FF',
            excelJS: 'ff747DFE',
            hoverBg: 'white',
            sidebar: {
                color: "#eeeeee"
            }
        },
        og: {
            title: 'Tkram Dev | Manage Your Rides & Earnings',
            description: 'Welcome to Tkram Dev. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
            image: tkramLogoTWWithBgB,
            type: 'website',
        },
        dispatcherSocket: true,
        firebase: false,
        chat: false,
        notifications: false,
        platform_fee: true,
        company_fee: true,
        fixed_otp: true,
        male_female: true,
        language_menu: true,
        del_activeRide_id: true,
        ride_history_imgWithApi: true,
        edit_driver_customer_phone_number: true,
        admin_notes: true,
        is_company_driver: true,
        customDirections: true,
        stripeKey: process.env.REACT_APP_STRIPE_KEY_TKRAM_DEVELOPMENT,
    },
};

const defaultConfig = {
    projectId: "roadrunner",
    language: 'en',
    distanceUnit: "km",
    country: 'us',
    tabIcon: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
    logo: logo,
    walletLogo: walletLogo,
    walletLogoBgColor: false,
    title: 'Road Runner',
    short_title: 'RR',
    bgImg: bgImg,
    email: "roadrunner@gmail.com",
    emailTemplate: EmailTemplateRR,
    login: {
        loginBgImg: loginBg,
        loginLogoBgColor: false,
        loginlogo: loginlogo,
        loginlogoSize: "100%"
    },
    theme: {
        mainColor: '#006496',
        ligthMain: '#f5fcff',
        meduimColor: '#C0EAFF',
        excelJS: 'ff006496',
        hoverBg: 'white',
        sidebar: {
            color: "#eeeeee"
        }
    },
    og: {
        title: 'Road Runner | Manage Your Rides & Earnings',
        description: 'Welcome to Road Runner. Track your trips, earnings, and ratings all in one place. Stay in control of your driving experience.',
        image: 'https://firebasestorage.googleapis.com/v0/b/ridewyze.appspot.com/o/logo.png?alt=media&token=0c835763-102c-4758-8ef3-f53a87bf0a85',
        type: 'website',
    },
    dispatcherSocket: false,
    firebase: true,
    chat: true,
    notifications: true,
    fixed_otp: false,
    male_female: true,
    language_menu: true,
    del_activeRide_id: false,
    ride_history_imgWithApi: false,
    edit_driver_customer_phone_number: false,
    stripeKey: process.env.REACT_APP_STRIPE_KEY_DEVELOPMENT,
};

const projectKey = process.env.REACT_APP_ENV || 'Default';


/**
 * Function to get the current configuration
 * @returns {object} The configuration for the current project
 */
const getProjectConfig = () => {
    return projectConfig[projectKey] || defaultConfig;
};

// Export the function
export default getProjectConfig;